<h1 mat-dialog-title>Edit</h1>
<div mat-dialog-content>
  <h3>{{name}}</h3>
  <p>{{data.value}}</p>
  <mat-form-field>
    <mat-label>Update Value</mat-label>
    <input matInput [(ngModel)]="value">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button [mat-dialog-close]="editFn()" cdkFocusInitial class="submit">Ok</button>
</div>
